export default function TableSkeleton({ rows = 8 }) {
  return (
    <div className="min-h-0 flex-1 overflow-hidden" aria-busy="true" aria-label="Memuat data">
      <table className="w-full min-w-[900px] table-fixed border-collapse">
        <thead className="border-b border-slate-200 bg-slate-50">
          <tr>
            {["w-16", "", "", "", "", "w-36"].map((w, i) => (
              <th key={i} className={`h-11 px-4 ${w}`}>
                <div className="h-3 w-16 animate-pulse rounded bg-slate-200" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <tr key={i} className="border-b border-slate-100">
              <td className="px-4 py-3.5">
                <div className="mx-auto h-4 w-6 animate-pulse rounded bg-slate-100" />
              </td>
              <td className="px-4 py-3.5">
                <div className="h-4 w-3/4 animate-pulse rounded bg-slate-100" />
              </td>
              <td className="px-4 py-3.5">
                <div className="h-4 w-20 animate-pulse rounded bg-slate-100" />
              </td>
              <td className="px-4 py-3.5">
                <div className="h-6 w-28 animate-pulse rounded-full bg-slate-100" />
              </td>
              <td className="px-4 py-3.5">
                <div className="h-4 w-16 animate-pulse rounded bg-slate-100" />
              </td>
              <td className="px-4 py-3.5">
                <div className="flex gap-3">
                  <div className="size-6 animate-pulse rounded bg-slate-100" />
                  <div className="size-6 animate-pulse rounded bg-slate-100" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
